import {createTheme} from "@mui/material/styles";

// MUI theme overrides (controlla brand styles)
export const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            // Purple and green play nicely together.
            main: '#FF74E9',
        },
        secondary: {
            // This is green.A700 as hex.
            main: '#FF74E9',
        },
        success: {
            main: '#55CDC4',
        },
        background: {
            default: '#0C0810',
            paper: '#180D23',
        }
    },
    components: {
        // Name of the component
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontSize: '14px',
                    height: '40px',
                    flexShrink: 0,
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                // Name of the slot
                root: ({ ownerState }) => ({
                    // Some CSS
                    borderRadius: '20px',
                    // flexGrow: 1, // TODO did this break something?
                    color: 'rgba(245, 225, 255, 0.74)',
                    fontFamily: 'Jura',
                    // Variant Overrides
                    ...(ownerState.variant === 'contained' &&
                        ownerState.color === 'primary' && {
                            color: '#140918',
                            fontWeight: 700,
                    }),
                }),
                outlined: {
                    borderColor: 'rgba(245, 225, 255, 0.74)',
                },
                sizeSmall: {
                    height: '40px',
                    paddingLeft: '15px',
                    paddingRight: '15px',
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#180D23',
                    backgroundImage: 'none',
                    padding: '20px',
                    borderRadius: '45px',
                    border: '1px solid rgba(255, 116, 233, 0.74)'
                },
                
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    fontFamily: 'Raleway',
                    fontSize: '34px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '123.5%', /* 41.99px */
                    letterSpacing: '0.25px',
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    borderTop: 'none',
                    borderBottom: 'none',
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '20px',
                    color: 'rgba(245, 225, 255, 0.74)',
                    fontFamily: 'Jura',
                    //border: '1px solid rgba(245, 225, 255, 0.74)',
                    '&:hover': {
                        border: '1px solid rgba(245, 225, 255, 0)',
                        outline: 'none',
                    },
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        color: '#FF74E9',
                    },
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    minWidth: '40px',
                    minHeight: '40px',
                },
                sizeSmall: {
                    minWidth: '32px',
                    minHeight: '32px',
                },
            }
        },
        MuiSlider: {
            styleOverrides: {
                valueLabel: ({ ownerState, theme }) => ({
                    ...(ownerState.orientation === 'horizontal' &&
                            ownerState.size === 'small' && {
                        backgroundColor: '#251A30',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        color: 'rgba(245, 225, 255, 0.74)',
                        '&:before': {
                            display: 'none',
                        },
                    }),
                }),
                thumb: ({ ownerState, theme }) => ({
                    // Custom transpose slider variant
                    ...(ownerState.variant === 'transpose' && {
                            background: 'linear-gradient(180deg, rgba(125,14,181,1) 0%, rgba(77,6,113,1) 100%)',
                            borderRadius: '50%',
                            width: '30px',
                            height: '30px',
                            color: 'rgba(245, 225, 255, 0.74)',
                            fontWeight: 700,
                            fontFamily: 'Jura',
                        }),
                }),
                root: ({ ownerState, theme }) => ({
                    ...(ownerState.variant === 'transpose' && {
                        color: 'rgba(245, 225, 255, 0.74)',
                    }),
                }),
            },
        }
    },
});